var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9962 17C16.1082 17 18.5827 13.933 19.6792 12.1047C19.7042 12.063 19.7111 12.0278 19.7111 12C19.7111 11.9722 19.7042 11.937 19.6792 11.8953C18.5827 10.067 16.1082 7 11.9962 7C7.88411 7 5.40959 10.067 4.31316 11.8953C4.28811 11.937 4.28125 11.9722 4.28125 12C4.28125 12.0278 4.28811 12.063 4.31316 12.1047C5.40958 13.933 7.88411 17 11.9962 17ZM21.3944 13.1334C20.2061 15.1148 17.2112 19 11.9962 19C6.78114 19 3.78623 15.1148 2.59795 13.1334C2.17568 12.4292 2.17568 11.5708 2.59795 10.8666C3.78623 8.88521 6.78114 5 11.9962 5C17.2112 5 20.2061 8.88521 21.3944 10.8666C21.8166 11.5708 21.8166 12.4292 21.3944 13.1334Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13ZM12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/show.262d9e4dca4df9897df059673bffa537.svg";
export { ForwardRef as ReactComponent };